export default "__VITE_ASSET__bT6wBwg8__"